import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import Gallery from "../components/Gallery";
import Testimonials from "../components/Testimonials";
import QuoteForm from "../components/QuoteForm";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main className="relative bg-[#08090B] text-gray-100">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Manifesto />
      <Gallery />
      <Testimonials />
      <QuoteForm />
      <Footer />
      <div className="noise-overlay" />
    </main>
  );
}
